<template lang="pug">
w-input.f-slug(
  v-bind=`{ value: thisValue, label, required }`
  ref='input'
  @input='input'
)
</template>

<script lang="js">
import isFunction from 'lodash-es/isFunction'
import WInput, { mixin } from '@/widgets/w-input'

export default {
  name: 'SlugField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'Slug'
    },
    required: {
      type: Boolean,
      default: false
    },
    default: {
      type: [ String, Function ],
      default: () => source => source.toLowerCase().replace(/\W+/g, _ => '-' )
    },
    source: String
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    thisValue() {
      return this.value || (
        isFunction( this.default )
           ? this.default( this.source || '' )
           : this.default
      )
    }
  }
}
</script>

<style lang="scss">
.f-slug {

}
</style>
.
